import { Injectable } from '@angular/core';
import { Permission } from '../admin/roles/roles.model';

/**
 * Master permission that grants access to all functionality
 */
const MASTER_PERMISSION = '*:*';

@Injectable({
  providedIn: 'root'
})
export class PermissionsService {

  /**
   * Check if user has specific permission
   * MASTER_PERMISSION is considered a master permission that grants access to everything
   */
  hasPermission(userPermissions: Permission[], permissionId: string): boolean {
    // Check for master permission first
    if (userPermissions.some(permission => permission.id === MASTER_PERMISSION)) {
      return true;
    }
    return userPermissions.some(permission => permission.id === permissionId);
  }

  /**
   * Check if user has any of the specified permissions (OR logic)
   * MASTER_PERMISSION is considered a master permission that grants access to everything
   */
  hasAnyPermission(userPermissions: Permission[], permissionIds: string[]): boolean {
    if (!permissionIds || permissionIds.length === 0) {
      return true; // No permissions required
    }

    // Check for master permission first
    if (userPermissions.some(permission => permission.id === MASTER_PERMISSION)) {
      return true;
    }

    return permissionIds.some(permissionId => 
      userPermissions.some(permission => permission.id === permissionId)
    );
  }

  /**
   * Check if user has all specified permissions (AND logic)
   * MASTER_PERMISSION is considered a master permission that grants access to everything
   */
  hasAllPermissions(userPermissions: Permission[], permissionIds: string[]): boolean {
    if (!permissionIds || permissionIds.length === 0) {
      return true; // No permissions required
    }

    // Check for master permission first
    if (userPermissions.some(permission => permission.id === MASTER_PERMISSION)) {
      return true;
    }

    return permissionIds.every(permissionId => 
      userPermissions.some(permission => permission.id === permissionId)
    );
  }

}
